import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { Tramitacao } from '@/models/processo-eletronico/tramitacao'

const tramitacaoShow = require("@/query/processo-eletronico/Tramitacao.graphql");

export class TramitacaoAPI extends BaseAPI<Tramitacao> {
  constructor() {
    super();
    //this.apiUrl = `${this.apiUrl}/tramitacoes`;
  }

  public findByProcessoId(
    processoId: number,
    page: Number,
    size: Number
  ): AxiosObservable<Tramitacao> {
    const data = {
      input: {processoId},
      inputPage: {
        page: page,
        size: size,
        sort: [""],
        ascendingSort: true
      }
    };

    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(tramitacaoShow),
        variables: data
      })
      .pipe(
        map((data: any) => {
          const { tramitacoes }  = data;
          return tramitacoes;
        })
      );
  }
}
